import React, { useEffect } from "react";
import "./App.css";

function App() {
  useEffect(() => {
    console.log("New AW version");
  }, []);
  useEffect(() => {
    // Add message listener to debug what messages are being received
    const handleMessage = (event) => {
      // Log all message types for debugging
      if (event.data?.type) {
        console.log(`📝 Message type: ${event.data.type}`);

        switch (event.data.type) {
          case "AUTH_COMPLETE":
            console.log(
              "✅ Authentication completed in React app!",
              event.data
            );
            break;
          case "AUTH_ERROR":
            console.log("❌ Authentication failed in React app!", event.data);
            // alert("❌ Authentication failed!");
            break;
          case "OPEN_AUTH_POPUP":
            console.log("🔓 Auth popup request received in React app");
            break;
          default:
            console.log("📨 Other message type received:", event.data.type);
        }
      }
    };

    // Add event listener
    window.addEventListener("message", handleMessage);
    console.log("👂 React app is now listening for messages");

    // Debug: Check if iframe exists
    setTimeout(() => {
      const iframe = document.getElementById("booking-flow");
      console.log(
        "🔍 Checking for iframe:",
        iframe ? "✅ Found" : "❌ Not found"
      );
      if (iframe) {
        console.log("📋 Iframe details:", {
          src: iframe.src,
          id: iframe.id,
          loaded: iframe.contentDocument ? "Yes" : "Loading...",
        });
      }
    }, 1000);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("message", handleMessage);
      console.log("🔇 React app stopped listening for messages");
    };
  }, []);

  return (
    <div className="App">
      {/* Background iframe - full page */}
      <div className="background-iframe-container">
        <iframe
          src="https://mollies.com/"
          title="Background Site"
          className="background-iframe"
        />
        <div className="background-overlay"></div>
      </div>

      {/* Main Content */}
      <main className="main-content">
        <div className="iframe-container">
          <iframe
            referrerPolicy="strict-origin-when-cross-origin"
            sandbox="allow-scripts allow-forms allow-modals allow-popups allow-popups-to-escape-sandbox allow-top-navigation allow-same-origin allow-top-navigation-by-user-activation allow-storage-access-by-user-activation"
            allow="payment 'src'; publickey-credentials-get 'src'; fullscreen 'src'; clipboard-write 'src'"
            allowPaymentRequest
            src="https://staging.bf.mollies.alliants.net"
            title="Mollies Booking Site"
            className="child-iframe"
            id="booking-flow"
            style={{
              border: "none",
              width: "100%",
              height: "100%",
              maxWidth: "522px",
              float: "right",
            }}
          />
        </div>
      </main>
    </div>
  );
}

export default App;
